import { render, staticRenderFns } from "./SelectArrowBase.vue?vue&type=template&id=63e8a525&scoped=true&lang=pug&"
import script from "./SelectArrowBase.vue?vue&type=script&lang=ts&"
export * from "./SelectArrowBase.vue?vue&type=script&lang=ts&"
import style0 from "./SelectArrowBase.vue?vue&type=style&index=0&id=63e8a525&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8a525",
  null
  
)

export default component.exports